// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-_Ae","productName":"Table_productName__-X8zt"};